import React, { Component } from "react";
import {
  Button,
  Card,
  Container,
  Form,
  Image,
  Message,
  Segment,
  Select
} from "semantic-ui-react";

import set from "lodash/set";
import barcode from "../../assets/img/sample-barcode.png";
import request from "../../utils/request";
import DropzoneCommon from "../../components/content/DropzoneCommon";

class Tickets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
      isLoading: true,
      xhrStatus: "",
      xhrMessage: "",
      nonProfit: {
        barcode_position: "middle"
      },
      nonProfitList: [],
      nonProfitOptions: [
        {
          key: 0,
          text: "Select Non-profit",
          value: 0
        }
      ],
      nonProfitId: 0,
      tablet: {
      },
      web: {
      },
      ticket_text_header: "",
      ticket_text: "",
      ticket_text_footer: "",
      web_ticket_text_header: "",
      web_ticket_text: "",
      web_ticket_text_footer: ""
    };
    this.handleTabletHeader = this.handleTabletHeader.bind(this);
  };
  componentDidMount = () => {
    this.setState({ isMounted: true });
    this.fetchData();
  };
  fetchData = () => {
    return request.get(this, "api:/non-profit", {}).then(resp => {
      let nonProfitOptions = this.state.nonProfitOptions;
      let nonProfitList = [];
      resp.data.map((value, index) => {
        nonProfitList[+value.id] = value;
        return nonProfitOptions.push({
          key: value.id,
          text: value.name,
          value: value.id
        });
      });
      this.setState({
        nonProfitList: nonProfitList,
        nonProfitOptions: nonProfitOptions,
        isLoading: false
      });
    });
  };
  handleNonProfit = (e, { name, value }) => {
    if (value == 0) {
      this.setState({ nonProfitId: 0 });
      return;
    }
    return request.get(this, "api:/content/ticket", {nonProfitId: value}).then(resp => {
      this.setState({
        [name]: value,
        nonProfit: this.state.nonProfitList[value],
        tablet: {
          header: (resp.tablet && resp.tablet.header) ? resp.tablet.header.url : "",
          middle: (resp.tablet && resp.tablet.middle) ? resp.tablet.middle.url : "",
          text: (resp.tablet && resp.tablet.text) ? resp.tablet.text.url : "",
          middle_e: (resp.tablet && resp.tablet.middle_e) ? resp.tablet.middle_e.url : "",
          footer: (resp.tablet && resp.tablet.footer) ? resp.tablet.footer.url : ""
        },
        web: {
          header: (resp.web && resp.web.header) ? resp.web.header.url : "",
          middle: (resp.web && resp.web.middle) ? resp.web.middle.url : "",
          text: (resp.web && resp.web.text) ? resp.web.text.url : "",
          middle_e: (resp.web && resp.web.middle_e) ? resp.web.middle_e.url : "",
          footer: (resp.web && resp.web.footer) ? resp.web.footer.url : ""
        },
        ticket_text_header: this.state.nonProfitList[value]['ticket_text_header'],
        ticket_text: this.state.nonProfitList[value]['ticket_text'],
        ticket_text_footer: this.state.nonProfitList[value]['ticket_text_footer'],
        web_ticket_text_header: this.state.nonProfitList[value]['web_ticket_text_header'],
        web_ticket_text: this.state.nonProfitList[value]['web_ticket_text'],
        web_ticket_text_footer: this.state.nonProfitList[value]['web_ticket_text_footer']
      });
    }); 
  }
  handleBarcodePosition = (e, { name, value }) => {
    let np = this.state.nonProfit;
    np.barcode_position = value;
    this.setState({ nonProfit: np });
    // Initial FormData
    let payload = {
      nonprofitid: this.state.nonProfitId,
      device: "tablet",
      position: "barcode_position",
      value: value
    };
    return request.post(
      this,
      "api:/content/ticket",
      payload,
      this.handleResponse
    );
  };

  handleTabletText = async (name, value) => {
    let np = this.state.nonProfit;
    if (name) {
      if (name === 'ticket_text_header') {
        if (np.ticket_text_header == value) {
          return;
        }
        np.ticket_text_header = value;
      }
      if (name === 'ticket_text') {
        if (np.ticket_text == value) {
          return;
        }
        np.ticket_text = value;
      }
      if (name === 'ticket_text_footer') {
        if (np.ticket_text_footer == value) {
          return;
        }
        np.ticket_text_footer = value;
      }
    }

    this.setState({ isLoading: true, nonProfit: np, xhrStatus: "", xhrMessage: "" });

    // Initial FormData
    let payload = {
      nonprofitid: this.state.nonProfitId,
      device: "tablet",
      position: name,
      value: value
    };

    let req = await request.post(
      this,
      "api:/content/ticket",
      payload,
      this.handleResponse
    );

    this.setState({isLoading: false});
    return req;
  };

  handleWebText = (name, value) => {
    let np = this.state.nonProfit;
    if (name) {
      if (name === 'web_ticket_text_header') {
        if (np.web_ticket_text_header == value) {
          return;
        }
        np.web_ticket_text_header = value;
      }
      if (name === 'web_ticket_text') {
        if (np.web_ticket_text == value) {
          return;
        }
        np.web_ticket_text = value;
      }
      if (name === 'web_ticket_text_footer') {
        if (np.web_ticket_text_footer == value) {
          return;
        }
        np.web_ticket_text_footer = value;
      }
    }

    this.setState({ nonProfit: np, xhrStatus: "", xhrMessage: "" });

    // Initial FormData
    let payload = {
      nonprofitid: this.state.nonProfitId,
      device: "web",
      position: name,
      value: value
    };
    return request.post(
      this,
      "api:/content/ticket",
      payload,
      this.handleResponse
    );
  };

  handleTabletHeader = files => this.handleUpload(files[0], "tablet", "header");
  handleTabletMiddle = files => this.handleUpload(files[0], "tablet", "middle");
  handleTabletMiddleE = files => this.handleUpload(files[0], "tablet", "middle_e");
  handleTabletFooter = files => this.handleUpload(files[0], "tablet", "footer");
  handleWebHeader = files => this.handleUpload(files[0], "web", "header");
  handleWebMiddle = files => this.handleUpload(files[0], "web", "middle");
  handleWebMiddleE = files => this.handleUpload(files[0], "web", "middle_e");
  handleWebFooter = files => this.handleUpload(files[0], "web", "footer");

  handleUpload = (file, device, position) => {
    // Initial FormData
    let formData = new FormData();
    formData.append("nonprofitid", this.state.nonProfitId);
    formData.append("file", file);
    formData.append("position", position);
    formData.append("device", device);
    return request.post(
      this,
      "api:/content/ticket",
      formData,
      this.handleResponse
    );
  };
  handleTrash = (device, position) => {
    // Initial FormData
    this.setState({
      isLoading: true
    });
    let payload = {
      position: position,
      device: device
    };
    return request.put(
      this,
      `api:/content/ticket/${this.state.nonProfitId}`,
      payload,
      this.handleResponse
    ).then(resp => {
      this.setState({
        isLoading: false
      });
    });
  };
  handleResponse = resp => {
    this.setState({
      xhrStatus: resp.success === true ? "success" : "error",
      xhrMessage: resp.message
    });
    if (resp.success === true) {
      let data = this.state[resp.device];
      set(data, resp.position, resp.url);
      this.setState({ [resp.device]: data });
    }
  };
  render() {
    const {
      isLoading,
      nonProfit,
      nonProfitId,
      nonProfitOptions,
      xhrMessage,
      xhrStatus
    } = this.state;
    return (
      <Container as={Segment} fluid loading={isLoading}>
        <Segment basic textAlign="center">
          <Select
            name="nonProfitId"
            label="Select Non-profit"
            placeholder="Select Non-profit"
            options={nonProfitOptions}
            value={nonProfitId}
            onChange={this.handleNonProfit}
          />
        </Segment>
        {nonProfitId > 0 && (
          <Segment basic textAlign="center">
            <Message
              hidden={xhrStatus === ""}
              success={xhrStatus === "success"}
              error={xhrStatus === "error"}
              content={xhrMessage}
            />
            <strong>Barcode Position</strong>
            <br />
            <Button.Group>
              <Button
                toggle
                type="button"
                value="top"
                active={nonProfit.barcode_position === "top"}
                onClick={this.handleBarcodePosition}
              >
                Top
              </Button>
              <Button.Or />
              <Button
                toggle
                type="button"
                value="middle"
                active={nonProfit.barcode_position === "middle"}
                onClick={this.handleBarcodePosition}
              >
                Middle
              </Button>
              <Button.Or />
              <Button
                toggle
                type="button"
                value="bottom"
                active={nonProfit.barcode_position === "bottom"}
                onClick={this.handleBarcodePosition}
              >
                Bottom
              </Button>
            </Button.Group>
            <br />
            <Card.Group centered>
              <Card>
                <Card.Content textAlign="center">
                  <Card.Header>Tablet</Card.Header>
                  {nonProfit.barcode_position === "top" && (<Image src={barcode} />)}
                  <DropzoneCommon
                    img={this.state.tablet.header}
                    accept="image/*"
                    onDrop={this.handleTabletHeader}
                    onTrash={() => this.handleTrash("tablet", "header")}
                  />
                  <p>
                    Raffle Date: YYYY-MM-DD
                    <br />
                    Purchased: YYYY-MM-DD
                    <br />
                    Device: 00 Ticket Price $100 Event: 1
                  </p>
                  {nonProfit.barcode_position === "middle" && (<Image src={barcode} />)}
                  <DropzoneCommon
                    img={this.state.tablet.middle}
                    accept="image/*"
                    onDrop={this.handleTabletMiddle}
                    onTrash={() => this.handleTrash("tablet", "middle")}
                  />
                  <Form id="ticketTabletText">
                    <Form.Input
                      name="ticket_text_header"
                      placeholder="Header"
                      value={this.state.ticket_text_header || ""}
                      onChange={e => {
                        this.setState({ ticket_text_header: e.target.value });
                        this.value = this.state.ticket_text_header;
                      }}
                      onBlur={e => { this.handleTabletText(e.target.name, this.state.ticket_text_header) }}
                    />
                    <Form.TextArea
                      name="ticket_text"
                      placeholder="Text"
                      value={this.state.ticket_text || ""}
                      onChange={e => {
                        this.setState({ ticket_text: e.target.value });
                        this.value = this.state.ticket_text;
                      }}
                      onBlur={e => { this.handleTabletText(e.target.name, this.state.ticket_text) }}
                    />
                    <Form.Input
                      name="ticket_text_footer"
                      placeholder="Footer"
                      value={this.state.ticket_text_footer || ""}
                      onChange={e => {
                        this.setState({ ticket_text_footer: e.target.value });
                        this.value = this.state.ticket_text_footer;
                      }}
                      onBlur={e => { this.handleTabletText(e.target.name, this.state.ticket_text_footer) }}
                    />
                  </Form>
                  <DropzoneCommon
                    img={this.state.tablet.middle_e}
                    accept="image/*"
                    onDrop={this.handleTabletMiddleE}
                    onTrash={() => this.handleTrash("tablet", "middle_e")}
                  />
                  <DropzoneCommon
                    img={this.state.tablet.footer}
                    accept="image/*"
                    onDrop={this.handleTabletFooter}
                    onTrash={() => this.handleTrash("tablet", "footer")}
                  />
                  {nonProfit.barcode_position === "bottom" && (<Image src={barcode} />)}
                </Card.Content>
              </Card>
              <Card>
                <Card.Content textAlign="center">
                  <Card.Header>Web</Card.Header>
                  {nonProfit.barcode_position === "top" && (<Image src={barcode} />)}
                  <DropzoneCommon
                    img={this.state.web.header}
                    accept="image/*"
                    onDrop={this.handleWebHeader}
                    onTrash={() => this.handleTrash("web", "header")}
                  />
                  <p>
                    Raffle Date: YYYY-MM-DD
                    <br />
                    Purchased: YYYY-MM-DD
                    <br />
                    Device: 00 Ticket Price $100 Event: 1
                  </p>
                  {nonProfit.barcode_position === "middle" && (<Image src={barcode} />)}
                  <DropzoneCommon
                    img={this.state.web.middle}
                    accept="image/*"
                    onDrop={this.handleWebMiddle}
                    onTrash={() => this.handleTrash("web", "middle")}
                  />
                  <Form id="ticketWebText">
                    <Form.Input
                      name="web_ticket_text_header"
                      placeholder="Header"
                      value={this.state.web_ticket_text_header || ""}
                      onChange={e => {
                        this.setState({ web_ticket_text_header: e.target.value });
                        this.value = this.state.web_ticket_text_header;
                      }}
                      onBlur={e => { this.handleWebText(e.target.name, this.state.web_ticket_text_header) }}
                    />
                    <Form.TextArea
                      name="web_ticket_text"
                      placeholder="Text"
                      value={this.state.web_ticket_text || ""}
                      onChange={e => {
                        this.setState({ web_ticket_text: e.target.value });
                        this.value = this.state.web_ticket_text;
                      }}
                      onBlur={e => { this.handleWebText(e.target.name, this.state.web_ticket_text) }}
                    />
                    <Form.Input
                      name="web_ticket_text_footer"
                      placeholder="Footer"
                      value={this.state.web_ticket_text_footer || ""}
                      onChange={e => {
                        this.setState({ web_ticket_text_footer: e.target.value });
                        this.value = this.state.web_ticket_text_footer;
                      }}
                      onBlur={e => { this.handleWebText(e.target.name, this.state.web_ticket_text_footer) }}
                    />
                  </Form>
                  <DropzoneCommon
                    img={this.state.web.middle_e}
                    accept="image/*"
                    onDrop={this.handleWebMiddleE}
                    onTrash={() => this.handleTrash("web", "middle_e")}
                  />
                  <DropzoneCommon
                    img={this.state.web.footer}
                    accept="image/*"
                    onDrop={this.handleWebFooter}
                    onTrash={() => this.handleTrash("web", "footer")}
                  />
                  {nonProfit.barcode_position === "bottom" && (<Image src={barcode} />)}
                </Card.Content>
              </Card>
            </Card.Group>
          </Segment>
        )}
      </Container>
    );
  }
}

export default Tickets;
